import { useEffect, useRef } from "react";
import { useMatch } from "react-router-dom";
import { appointmentForm } from "Routes/paths";

const ZENDESK_API_KEY = process.env.REACT_APP_ZENDESK_API_KEY;

export const useZendeskChat = () => {
  const zendeskRef = useRef(null);
  const zendeskScriptLoaded = useRef(false);
  const isSchedulerPath = useMatch(appointmentForm);

  useEffect(() => {
    if (zendeskScriptLoaded.current || isSchedulerPath) return;

    const scriptTag = document.createElement("script");
    scriptTag.id = "ze-snippet";
    scriptTag.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_API_KEY}`;

    if (zendeskRef.current) {
      zendeskRef.current.appendChild(scriptTag);
      zendeskScriptLoaded.current = true;
    }
  }, [isSchedulerPath]);

  return zendeskRef;
};
